// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgTrendDownIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M17.378 17.921c.25-.1.44-.3.54-.54.05-.12.08-.25.08-.38v-9c0-.55-.45-1-1-1s-1 .45-1 1v6.59L7.7 6.291a.997.997 0 0 0-1.7.71c0 .26.1.51.29.71l8.297 8.29H7.99c-.55 0-1 .45-1 1s.45 1 1 1h9.008c.13 0 .26-.03.38-.08" />
  </g>
);
export default SvgTrendDownIcon;
SvgTrendDownIcon.displayName = 'SvgTrendDownIcon';
